'use strict';

var ngModule = 'frontend.landing';

require('angular')
  .module(ngModule, [])
  .component('landing', require('./landing'));

module.exports = ngModule;



/*****************
 ** WEBPACK FOOTER
 ** ./src/app/landing/index.js
 ** module id = 186
 ** module chunks = 0
 **/